import { CreateDogDtoSchema } from '@lyka-pet-food/contracts'
import { z } from 'zod'

export const CreateDogSchema = z.object({
  dog: CreateDogDtoSchema,
  productIds: z.string().array(),
})

export type CreateDog = z.infer<typeof CreateDogSchema>
